import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import siteUtils from "../utils/siteUtils";
import RequestUtils from "../utils/requestUtils";
import ViewRequestPopUp from "../components/ViewRequestPopUp";
import EarlyWarningScoresPopup from "../components/EarlyWarningScoresPopUp";
import RoleUtils from "../utils/roleUtils";
import ServiceCalls from "../utils/serviceCalls";
import "../styles/Vendor.css";


const WorklistRequestDetails = (props) => {
	const { Request, currentUser, currentCompanyId } = props;
	const [showPopup, setShowPopup] = useState(false);
	const [popupData, setPopupData] = useState(null);
	const requestType = RequestUtils.determineRequestType(Request?.bankRequest?.requestTypeId);
	const isUHGRolesView = requestType !== "CANCEL" && RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.uhgRolesOnly());
	const requestStatus = Request.bankRequest && RequestUtils.determineRequestStatus(Request.bankRequest.requestStatusId).toUpperCase();

	const handlePopupOpen = (data) => {
		setPopupData(data);
		setShowPopup(true);
	};

	const handlePopupClose = () => {
		setShowPopup(false);
		setPopupData(null);
	};

	const buildTable = () => {
		if (Request) {
			const { bankRequest, vendorRecord, requestor, bankRecord } = Request;
			//DE1072063 - Hide EW details from EMEA suppliers and CANCEL requests
			var isEMEAVendor = siteUtils.determineIfVendorIsEMEAPlus(vendorRecord);
			var requestType = RequestUtils.determineRequestType(bankRequest.requestTypeId);

			// DE786961 Early Warning Incorrectly Displayed
			// DE792161 Date Should be Blank.
			const { mostRecentCall, mostRecentScore: ewScore } = RequestUtils.getMostRecentEarlyWarningScoreAndCall(Request.bankRequest);
			const combinedCalls = RequestUtils.getSortedEarlyWarningCalls(bankRequest)

			let earlyWarningResponseObject, nameMatch, taxIdMatch;
			if (isUHGRolesView) {
				earlyWarningResponseObject = bankRequest && JSON.parse(bankRequest.earlyWarningResponse);

				if (mostRecentCall) {
					// Determine match values based on the request type
					const matchResults = mostRecentCall?.earlyWarningResponse?.account_ownership?.match_results;

					if (mostRecentCall.earlyWarningRequestTypeId === 1) { // Business
						nameMatch = matchResults?.business?.name_match;
						taxIdMatch = matchResults?.business?.tax_id_number_match;
					} else if (mostRecentCall.earlyWarningRequestTypeId === 2) { // Individual
						nameMatch = matchResults?.individual?.full_name_match;
						taxIdMatch = matchResults?.individual?.tax_id_number_match;
					}
				}

				// Handle the case where there is only one call (always business)
				if (combinedCalls.length === 1) {
					const singleCallResponse = earlyWarningResponseObject?.account_ownership?.match_results;

					nameMatch = singleCallResponse?.business?.name_match || "";
					taxIdMatch = singleCallResponse?.business?.tax_id_number_match || "";
				}
			}

			
			return (
				<div>
					<table className="request-details-table">
						<tbody>
							<tr>
								<th>Request ID</th>
								<th>Supplier Set ID</th>
								<th>Supplier ID</th>
								<th>Supplier Name</th>
								<th>Requestor Last Name</th>
								<th>Requestor First Name</th>
								<th>Requestor Email</th>
								<th>Request Type</th>
								<th>Submitted Date</th>
								<th>Request Status</th>
								<th>Status Date</th>
							</tr>
							<tr>
								<td>{bankRequest && bankRequest.vendorBankRequestId}</td>
								<td>{vendorRecord && vendorRecord.vendorSetId}</td>
								<td>{bankRecord && bankRecord.vendorId}</td>
								<td>{vendorRecord && vendorRecord.name}</td>
								<td className="request-details-table-wordWrap">{requestor && requestor.lastName}</td>
								<td className="request-details-table-wordWrap">{requestor && requestor.firstName}</td>
								<td className="request-details-table-wordWrap-reqEmail">{requestor && requestor.email}</td>
								<td>{requestType}</td>
								<td>{bankRequest && siteUtils.formatDate(bankRequest.createdDt)}</td>
								<td>{bankRequest && RequestUtils.determineRequestStatus(bankRequest.requestStatusId).toUpperCase()}</td>
								<td>{requestStatus === "NEW" ? "" : bankRequest && bankRequest.updatedDt && siteUtils.formatDate(bankRequest.updatedDt)}</td>
							</tr>
							{isUHGRolesView && ewScore !== "N/A" && !isEMEAVendor && (requestType !== "CANCEL") && (
								<>
									<tr>
										<th>EW Score</th>
										<th>EW Name Match</th>
										<th>EW TIN Match</th>
                                        <th>EW Date/Time</th>
									</tr>
									<tr>
										<td>{<span style={{ color: RequestUtils.getColor(ewScore) }}>{ewScore}</span>}</td>
										<td>{<span>{nameMatch}</span>}</td>
										<td>{<span>{taxIdMatch}</span>}</td>
										<td>{mostRecentCall?.timestamp && siteUtils.formatDate(mostRecentCall.timestamp, true)}</td>
										{/*DE1084764 - Added Approved and Rejected statuses to display previous calls */}
										{["APPROVED","NEW", "IN PROCESS", "PENDING CLIENT","REJECTED"].includes(requestStatus) && combinedCalls.length > 1 && (
											<td>
												Click here to view previous <span style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }} onClick={() => handlePopupOpen({ earlyWarningResponseObject, bankRequest, ewScore })}>EW Scores</span>
											</td>)}</tr>
								</>
							)}
						</tbody>
					</table>
				</div>
			);
		}
	};

	// 	US6782921: Resubmit Message
	const showResubmitReminder = () => {
		const hasEditBankRole = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.profileEditBankRoles());
		if (requestStatus === "PENDING CLIENT" && hasEditBankRole) {
			return <h3 className="resubmitBtnHeaderText">Please select 'Resubmit' button after adding comments or attachments.</h3>;
		}
	};

	return (
		<>
			<Container fluid>
				<Row>
					<Col md={10}>{showResubmitReminder()}</Col>
					<Col md={2}>
						<Link to="/Worklist" title="Return to worklist">
							<h5 className="mr-3 right" style={{ paddingTop: "6px" }}>
								Return to Worklist
							</h5>
						</Link>
					</Col>
				</Row>
				<Row className="d-flex align-items-center">
					<Col md={2}>
						<h3 className="commentsHeader">Request Details</h3>
					</Col>
					<Col md={10} className="d-flex justify-content-end">
						<ViewRequestPopUp Request={Request} currentUser={props.currentUser} currentCompanyId={currentCompanyId} />
					</Col>
				</Row>
			</Container>

			<Container className="vendorArea border-left-dark shadow borderCurve worklistTable requestDetailsTableContainer" fluid>
				{buildTable()}
			</Container>

			{showPopup && <EarlyWarningScoresPopup data={popupData} onClose={handlePopupClose} />}
		</>
	);
};
export default WorklistRequestDetails;
